const bulletPrefix = /^\s*(?:[-*•]|\d+[.)])\s+/;

export function stripBlueprintBulletPrefix(value: string) {
  return value.replace(bulletPrefix, '');
}

export function cleanBlueprintChange(value: string) {
  return stripBlueprintBulletPrefix(value).trim();
}

export function serializeBlueprintChangelog(items: string[]) {
  return items
    .map(cleanBlueprintChange)
    .filter(Boolean)
    .map((item) => `- ${item}`)
    .join('\n');
}

export function parseBlueprintChangelog(value: string) {
  return value.split(/\r?\n/).map(cleanBlueprintChange).filter(Boolean);
}
